import { Component } from '@angular/core';
import { OnboardingProvider } from 'src/providers/onboarding/onboarding.provider';

@Component({
  selector: 'select-restocking-option-onboarding',
  templateUrl: './select-restocking-option-onboarding.html',
  styleUrls: ['./select-restocking-option-onboarding.scss']
})
export class SelectRestockingOptionOnboarding {
  constructor(
    public onboardingProvider: OnboardingProvider
  ) {}
} 